module.exports = __webpack_public_path__ + "static/media/periodic_grey.5fedac9a.svg";